import { Helmet } from 'react-helmet-async';
import { Box, Typography } from '@mui/material';

// Site Visit = the FULL task catalogue at /capture/visit/. ONE codebase and ONE
// catalogue: /capture/visit/ shares app.js + tasks.js from ../w1/; tasks tagged
// `hide: true` in tasks.js are dropped by the crew phone tool (/capture/w1/) and
// shown here (Yuval, 29/09). Same-origin localStorage keeps ticks consistent.
export default function SiteVisitPage() {
  return (
    <>
      <Helmet>
        <title> Site Visit | TERRRA </title>
      </Helmet>

      <Box sx={{ px: 2, pb: 2, height: 'calc(100vh - 140px)', display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4" sx={{ mb: 1 }}>Site Visit</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
          The full field task catalogue — every gate and task. The crew's no-login phone tool carries a reduced subset of these.
        </Typography>
        <Box sx={{ flexGrow: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1.5, overflow: 'hidden' }}>
          <iframe
            src="/capture/visit/"
            title="TERRRA field capture"
            style={{ border: 0, width: '100%', height: '100%' }}
            allow="geolocation; camera"
          />
        </Box>
      </Box>
    </>
  );
}
